import { render, staticRenderFns } from "./view-image.vue?vue&type=template&id=c0c931ae"
import script from "./view-image.vue?vue&type=script&lang=js"
export * from "./view-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports